import { NavigateFunction } from "react-router-dom";
import userLogout from "./userLogout";

export type SettingsItemKey =
  | "settings"
  | "analytics"
  | "managerGuide"
  | "playerGuide"
  | "logout";

export type SettingsItem = {
  key: SettingsItemKey;
  label: string;
  isNew?: boolean;
};

export function getSettingsItems(managerMode: number, betaMode: boolean): SettingsItem[] {
  const items: SettingsItem[] = [{ key: "settings", label: "Settings" }];
  if (managerMode === -1 || betaMode) {
    items.push({ key: "analytics", label: "Analytics", isNew: true });
  }
  if (managerMode === -1 || managerMode === -4 || betaMode) {
    items.push({ key: "managerGuide", label: "Manager Guide" });
  }
  if (managerMode > 1 || managerMode === -5) {
    items.push({ key: "playerGuide", label: "Player Guide" });
  }
  items.push({ key: "logout", label: "Logout" });
  return items;
}

export function runSettingsItem(
  key: SettingsItemKey,
  navigate: NavigateFunction,
  devPort: string
) {
  switch (key) {
    case "settings":
      navigate("/user-settings");
      break;
    case "analytics":
      navigate("/analyticsRevamp");
      break;
    case "managerGuide":
      window.open("https://chukkerbook.gitbook.io/docs", "_blank");
      break;
    case "playerGuide":
      window.open("https://chukkerbook.gitbook.io/player", "_blank");
      break;
    case "logout":
      userLogout(devPort);
      navigate("/account-login");
      break;
  }
}
